module.exports = __webpack_public_path__ + "img/desk-bottom.de08908c.png";